import dynamic from 'next/dynamic';
import { ComponentConfig } from '@zapier/builder.io-kit';

export const config: ComponentConfig = {
  name: 'Avatar',
  description: `Displays a user's avatar. Falls back to their initials if an invalid image url or no image url is provided.`,
  category: 'Zapier Sign Up Blocks',
  // @ts-ignore
  component: dynamic(() =>
    import('@zapier/design-system').then(mod => mod.Avatar)
  ),
  inputs: [
    {
      name: 'url',
      friendlyName: 'Icon Image',
      type: 'string',
      defaultValue: '',
      helperText: 'URL to img.',
    },
    {
      name: 'size',
      friendlyName: 'Size',
      type: 'text',
      defaultValue: 60,
      enum: [{ label: '60px', value: 60 }],
      helperText: 'Size of the Avatar to display',
    },
  ],
};
